export default "__VITE_ASSET__BUilCyhV__"